
import { defineComponent, computed } from 'vue';

import AppSider from '@/components/app-aside/index.vue';
import AppHeader from '@/components/app-header/index.vue';
import AppBody from '@/components/app-body/index.vue';
import AppFooter from '@/components/app-footer/index.vue';
import LogoIcon from '@/assets/logo.png';
import { useAppStore } from '@/store/app';

import useSide from './composables/use-side';
import useHeader from './composables/use-header';
import useBody from './composables/use-body';
import { useResizeHandler } from './composables/use-resize-handler';

import { SYSTEM_INFO_ENUM } from '@/constant';

export default defineComponent({
  name: 'MainLayout',
  components: {
    AppSider,
    AppHeader,
    AppBody,
    AppFooter,
  },
  setup() {
    // side 组件使用
    const {
      sidebar,
      isCollapse,
      menus,
    } = useSide();
    // header 组件
    const {
      accountData,
      handleLogout,
      handleToggleSideBar,
    } = useHeader();
    // body 组件
    const { viewKey } = useBody();

    useResizeHandler();
    const appState = useAppStore();

    const layoutClassName = computed(() => {
      return {
        'screen-size': appState.screenSize,
        'sidebar-show': appState.sidebar.opened,
        'sidebar-hide': !appState.sidebar.opened,
        'without-animation': appState.sidebar.withoutAnimation,
      };
    });

    const handleClickOutside = () => {
      appState.closeSideBar(false);
    };

    return {
      accountData,
      handleLogout,
      screenSize: appState.screenSize,
      layoutClassName,
      handleClickOutside,
      viewKey,
      handleToggleSideBar,
      menus,
      sidebar,
      isCollapse,
      SYSTEM_INFO_ENUM,
      LogoIcon,
    };
  },
});
